import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { HEADERS_GET } from './../constante';
import { URL_API } from './../constante';

@Injectable()
export class CaptchaService {

	private headers = HEADERS_GET;
	private usuarioUrl = URL_API + "/captcha/";
  
	constructor(private http: Http) { }

	validaCaptcha(token: string): Promise<any> {		
	
		return this.http.get(this.usuarioUrl+token)
                    .toPromise()
                    .then(response => response.json())
					.catch((error) => this.handleError(error));
	}
  
	private handleSuccess(resp: any): Promise<any> {
	  console.log(JSON.stringify(resp));
	  
	  return resp;
	}

	handleError(error: any): Promise<any> {
		console.error('An error occurred', error);
		//console.log(JSON.stringify(error));
		
		return error;
	}
	
  
}



// WEBPACK FOOTER //
// ./src/app/captcha/captcha.service.ts